import { LeaveTime } from '../LeaveTime.enum'

function getLabel(val: LeaveTime) {
  switch (val) {
    case LeaveTime.AM:
      return 'AM'
    case LeaveTime.PM:
      return 'PM'
    case LeaveTime.FULL_DAY:
      return 'Full Day'
    default:
      return ''
  }
}

const LeaveTimeEnumHelper = {
  getLabel,
}

export default LeaveTimeEnumHelper
